import React, { useId } from 'react';

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options: SelectOption[];
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(({ label, error, helperText, options, className = '', id, ...props }, ref) => {
  const reactId = useId();
  const selectId = id || `select-${reactId}`;

  return (
    <div className="space-y-2">
      {label && (
        <label htmlFor={selectId} className="block text-sm font-medium text-neutral-700">
          {label}
        </label>
      )}
      <select
        id={selectId}
        ref={ref}
        className={`block w-full rounded-lg border ${error ? 'border-red-500 focus:ring-red-500' : 'border-neutral-300 focus:ring-blue-500'} bg-white px-4 py-3 text-base text-neutral-800 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 ${className}`.trim()}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="text-sm text-red-600">{error}</p>}
      {helperText && !error && <p className="text-sm text-neutral-500">{helperText}</p>}
    </div>
  );
});

Select.displayName = 'Select';
